<template>
  <div class="header-content">
    <div class="left">
      <img src="@/assets/img/layout/logo.png" />
    </div>
    <div class="middle">
      <div class="menu-item" v-for="(item, index) of menuList" :key="item.menuId" @click="changeMenu(index)">
        <icon class="menu-icon" :name="mainMenuIndex === index ? item.iconPath : item.iconPath + '-bai'"></icon>
        <span>{{ item.menuName }}</span>
      </div>
    </div>
    <div class="right">
      <user></user>
    </div>
  </div>
</template>

<script>
import User from './User'
import Help from '@/views/help/Index'
export default {
  name: 'HeaderBar',
  props: {
    menuList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      activeIndex: 0,
      layers: {
        road: true,
        satellite: false,
        cad: true
      },
      cadDisabled: true,
      showDialog: false,
      title: ''
    }
  },
  components: {
    User,
    Help
  },
  computed: {
    mainMenuIndex() {
      return parseInt(this.$store.state.mainMenuIndex)
    },
    userInfo() {
      return this.$store.state.userInfo
    },
    theme() {
      return this.$store.state.theme
    }
  },
  created() {
    // do something
  },
  methods: {
    changeMenu(index) {
      this.$store.commit('setMainMenuIndex', index)
    },
    onMenuSelect(index) {
      switch (index) {
        case '1-1': // 新建
          // this.$event.$emit('newProject')
          this.$router.push('/new')
          break
        case '1-2': // 编辑
          this.$router.push('/edit')
          break
        case '1-3': // 导入
          this.$event.$emit('importCad')
          break
        case '1-4': // 导出
          break
        case '2': // 制图
          this.$router.push('/measure')
          break
        case '3-1': // 卫星云图
          this.layers.satellite = !this.layers.satellite
          this.$event.$emit('toggleLayer', {
            type: 'gaodeImgSource',
            visible: this.layers.satellite
          })
          break
        case '3-2': // 平面地图
          this.layers.road = !this.layers.road
          this.$event.$emit('toggleLayer', {
            type: 'gaodeRoadSource',
            visible: this.layers.road
          })
          break
        case '3-3': // CAD图
          this.layers.cad = !this.layers.cad
          this.$event.$emit('toggleLayer', {
            type: 'cadSource',
            visible: this.layers.cad
          })
          break
        case '4-1': // AutoCAD
          // shell.openExternal('https://www.baidu.com')
          window.electronAPI.openSoftware('acad')
          break
        case '4-2': // Sketchup
          window.electronAPI.openSoftware('Sketchup')
          break
        case '4-3': // Photoshop
          window.electronAPI.openSoftware('Photoshop')
          break
        case '5-1': // 暗黑
          this.setTheme('black')
          break
        case '5-2': // 高级灰
          this.setTheme('grey')
          break
        case '5-3': // 科技蓝
          this.setTheme('blue')
          break
        case '6-1': // 智库问答
          this.showDialog = true
          this.title = '智库问答'
          break
        case '6-2': // 操作手册
          this.showDialog = true
          this.title = '操作手册'
          break
        case '6-3': // 常见问题
          this.showDialog = true
          this.title = '常见问题'
          break
        default:
      }
    },
    setTheme(theme) {
      this.$store.commit('setTheme', theme)
    }
  }
}
</script>
<style lang="scss">
.header-menus {

  .el-menu-item,
  .el-submenu {
    padding-left: 30px !important;
    transition: none !important;
    color: #000000 !important;

    .el-submenu__title {
      padding-left: 0 !important;
      transition: none !important;
      color: #000000 !important;
    }

    &:hover {
      background-color: var(--tool-bar-menu-hover-color) !important;

      .el-submenu__title {
        background-color: transparent !important;
      }
    }

    i.checked {
      position: absolute;
      left: 8px;
      top: 50%;
      transform: translate3d(0, -50%, 0);
      font-size: 12px;
      margin-right: 0;
    }
  }
}
</style>

<style scoped lang="scss">
.header-content {
  position: relative;
  height: 90px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: url('../../assets/img/layout/topbar.png') no-repeat;
  background-size: 100% 100%;
}

.middle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  display: flex;
  align-items: center;

  .menu-item {
    display: flex;
    align-items: center;
    cursor: pointer;

    &:nth-child(n + 2) {
      margin-left: calc(72 / 1920 * 100vw);
    }

    .menu-icon {
      font-size: calc(28 / 1920 * 100vw);
    }

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      margin-left: 8px;
      white-space: nowrap;
    }
  }
}

.el-menu {
  border: 0 !important;
  background: unset !important;
  color: #ffffff !important;

  ::v-deep {
    .el-icon-arrow-down {
      display: none;
    }

    .el-menu-item,
    .el-submenu__title {
      border: 0 !important;
      height: 30px !important;
      line-height: 30px !important;
      transition: none !important;
      font-weight: 400;
      font-size: 13px;
      color: #ffffff !important;
      padding: 0 8px !important;

      &:hover {
        background: #003aaf !important;
      }

      .iconfont {
        margin-right: 5px;
        color: #ffffff;

        &.icon-cengji {
          font-size: 20px;
        }

        &.icon-wenjian {
          font-size: 14px;
        }

        &.icon-menu_cjgl {
          font-size: 14px;
        }

        &.icon-a-bangzhu1 {
          font-size: 14px;
        }
      }

      .right {}
    }

    .el-menu-item.is-active {
      border: 0;
    }
  }
}
</style>
